import { Component, ChangeDetectionStrategy } from '@angular/core'
import { MatDialogRef as MatDialogRef } from '@angular/material/dialog'

@Component({
  templateUrl: './lasku.muokkaus-estetty.dialog.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class LaskuMuokkausEstettyDialog {
  virhe: Error | null

  constructor(private dialogRef: MatDialogRef<LaskuMuokkausEstettyDialog>) {}
}
